import "./App.css";
import { Canvas1 } from "./Components/Canvas";
import Overlay from "./Components/Overlay";
import VideoIntro from "./Components/VideoComponent";
import { useRef, useState } from "react";

export default function App() {
  const overlay = useRef();
  const caption = useRef();
  const scroll = useRef(0);
  const [isIntro, setIsIntro] = useState(true);
  const [isFanRotating, setIsFanRotating] = useState(false);

  return (
    <div className="App">
      {isIntro ? (
        <>
          <VideoIntro handleSkip={() => setIsIntro(false)} />
        </>
      ) : (
        <>
          <Canvas1 scroll={scroll} fov={40} isFanRotating={isFanRotating} />
          <Overlay ref={overlay} caption={caption} scroll={scroll} setIsFanRotating={setIsFanRotating} />
        </>
      )}
    </div>
  );
}
